import { render } from "./App.vue?vue&type=template&id=c4f4ed88"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c4f4ed88&lang=css"
script.render = render

export default script